import { Chip, Typography } from '@mui/material';
import { formatAmount } from './money';

/** Kurumsal politika bütçe aşımı işareti — `AirResultsList`'teki birebir markup'ın ortak
 *  yeri. Metinler mevcut testlerle kilitli: "Kural Dışı Fiyat", "Kural dışı fiyat içerir",
 *  `(bütçe: 3.000)`. */

export interface OutOfBudgetTextProps {
  maxBudget?: number | null;
}

/** Fiyatın hemen altına konan uyarı satırı (fare kartı). */
export function OutOfBudgetText({ maxBudget }: OutOfBudgetTextProps) {
  return (
    <Typography variant="caption" color="warning.main" component="div" sx={{ fontWeight: 600 }}>
      Kural Dışı Fiyat
      {typeof maxBudget === 'number' ? ` (bütçe: ${formatAmount(maxBudget)})` : ''}
    </Typography>
  );
}

/** Kart özetinde "bu itinerary bütçe dışı ücret içeriyor" çipi. */
export function OutOfBudgetChip() {
  return <Chip size="small" color="warning" variant="outlined" label="Kural dışı fiyat içerir" />;
}
